import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function FooterButtons({
  saveButtonEnabled,
  onCancel,
  onSubmit,
  buttonMessage,
  isLoading,
  isFailed,
  crmObjectType,
  appName
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(LoadingButton, {
      "data-test-id": `${appName}-association-modal-panel-save-button`,
      type: "submit",
      use: "primary",
      loading: isLoading,
      failed: isFailed,
      onClick: onSubmit,
      disabled: !saveButtonEnabled,
      responsive: false,
      "data-selenium-test": `${appName}-save`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: buttonMessage,
        options: {
          objectType: crmObjectType
        }
      })
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onCancel,
      responsive: false,
      "data-selenium-test": `${appName}-cancel`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "associationsPanel.cancelButton"
      })
    })]
  });
}
export default FooterButtons;